// extracted by mini-css-extract-plugin
export default {"container":"TouchableOpacity_container__cvrmD"};